/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_P_Lead_NameInputs */

const en_cp_p_lead_name = /** @type {(inputs: Cp_P_Lead_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campus Lead`)
};

const id_cp_p_lead_name = /** @type {(inputs: Cp_P_Lead_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campus Lead`)
};

/**
* | output |
* | --- |
* | "Campus Lead" |
*
* @param {Cp_P_Lead_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_p_lead_name = /** @type {((inputs?: Cp_P_Lead_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_P_Lead_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_p_lead_name(inputs)
	return en_cp_p_lead_name(inputs)
});